import React from 'react'
import { intl } from 'lang/intl'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'

import {
  Button as ButtonComponent,
  BadgeComponent,
  // @ts-expect-error — importing js
} from '../../../../components'

import useFeatures from '../../../../hooks/useFeatures'

import './WebinarPresenterSidebarActionButtonsComponent.scss'

interface WebinarPresenterSidebarActionButtonsComponentProps {
  accentColor: string
  onActivityClick: (event: React.MouseEvent<HTMLElement>) => void
  onQuestionsClick: (event: React.MouseEvent<HTMLElement>) => void
  unreadQuestionsCount: number
  currentlySelectedSecondaryPanel?: 'questions'
}

const WebinarPresenterSidebarActionButtonsComponent = ({
  accentColor,
  onActivityClick,
  onQuestionsClick,
  unreadQuestionsCount,
  currentlySelectedSecondaryPanel,
}: WebinarPresenterSidebarActionButtonsComponentProps) => {
  const { HasWebinarSpeakerQuestions } = useFeatures()

  const chatButtonLabel = intl.formatMessage({ defaultMessage: 'Chat' })

  return (
    <div className="webinar-presenter-sidebar-action-buttons-component">
      <div
        className={classnames('button-wrapper', {
          'selected-secondary-panel': !currentlySelectedSecondaryPanel,
        })}
      >
        <ButtonComponent
          onClick={onActivityClick}
          color="transparent"
          className="action-button activity"
          ariaLabel={chatButtonLabel}
          size="small"
          data-active
        >
          {chatButtonLabel}
        </ButtonComponent>
      </div>
      {HasWebinarSpeakerQuestions && (
        <div
          className={classnames('button-wrapper', {
            'selected-secondary-panel':
              currentlySelectedSecondaryPanel === 'questions',
          })}
        >
          <BadgeComponent
            color={accentColor}
            count={unreadQuestionsCount}
            className="badge"
            offset={[-5, 10]}
          >
            <ButtonComponent
              onClick={onQuestionsClick}
              color="transparent"
              className="action-button"
              size="small"
            >
              <FormattedMessage defaultMessage="Questions" />
            </ButtonComponent>
          </BadgeComponent>
        </div>
      )}
    </div>
  )
}

export default WebinarPresenterSidebarActionButtonsComponent
